<template>
  <div class="uploadImage">
    <img
      :style="{ 'background-size': size }"
      :class="[
        {soft: type === 'soft' && (!value || loadFail)},
        {sharp: type === 'sharp' && (!value || loadFail)},
        'empty-picture']"
      :src="(!loadFail && imageSrc) || require('../../assets/img/circle-border-lg.svg')"
      alt="empty-picture"
      @error="failedLoad"
    >
    <img
      v-if="!disableUpload && isAvatar"
      class="empty-picture_edit"
      src="../../assets/img/edit-white-sm.svg"
      alt="edit-picture"
      @click="showAvatarPicker">
    <label
      v-else-if="!disableUpload"
      @click="$emit('loadStart')"
    >
      <img
        class="empty-picture_edit"
        src="../../assets/img/edit-white-sm.svg"
        alt="edit-picture"
      >
      <input
        class="image-input"
        ref="uploadInput"
        name="uploadInput"
        type="file"
        accept=".png, .jpg, .jpeg"
        @change="loadFile"
      >
    </label>
    <b-modal
      v-if="isAvatar"
      ignore-enforce-focus-selector=".header"
      modal-class="padding-top_modal-list"
      hide-header
      hide-footer
      dialog-class="app__avatar-picker-modal"
      body-class="modal_body"
      content-class="modal_content"
      id="avatar-picker">
      <avatar-picker-modal @loadFile="loadFile" :list="avatarsList" />
    </b-modal>
  </div>
</template>

<script>
import AvatarPickerModal from '../../components/AvatarPickerModal/AvatarPickerModal';

export default {
  name: 'ImageUpload',
  props: {
    type: {
      type: String,
      default: 'soft',
      validate: (val) => ['sharp', 'soft'].includes(val),
    },
    disableUpload: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '59px',
    },
    value: {
      type: String,
      default: '',
    },
    isCropActive: {
      type: Boolean,
      default: true,
    },
    isAvatar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadFail: false,
    };
  },
  methods: {
    async loadFile(event) {
      this.loadFail = false;

      let imageFile;
      if (event.avatar) {
        const data = await fetch(event.avatar);
        imageFile = await data.blob();
      } else {
        // eslint-disable-next-line prefer-destructuring
        imageFile = event.target.files[0];
      }
      this.$emit('loadImage', imageFile);

      const { uploadInput } = this.$refs;
      if (uploadInput) {
        this.$refs.uploadInput.type = 'text';
        this.$refs.uploadInput.type = 'file';
      }

      this.$bvModal.hide('avatar-picker');
    },
    failedLoad() {
      this.loadFail = true;
    },
    showAvatarPicker() {
      this.$bvModal.show('avatar-picker');
    },
  },
  computed: {
    imageSrc() {
      if (this.cropperInfo && this.cropperInfo.destination) {
        return this.cropperInfo.destination;
      }
      let src = '';
      if (this.value && this.value.indexOf('base64') !== -1) {
        src = this.value;
      } else if (this.value && this.value.indexOf('{size}') !== -1) {
        src = `//${this.value}`;
      }
      const index = src.indexOf('{size}');
      if (index !== -1) {
        src = src.split('');
        src.splice(index, 6, '140x140');
        return src.join('');
        // return `${src.join('')}djas`;
      }
      this.$emit('imageError', src.length > 1000000 ? this.$t('CP.errorPictureCropUrlSize') : '');

      // eslint-disable-next-line global-require
      return src || require('../../assets/img/circle-border-lg.svg');
    },
    avatarsList() {
      const path = require.context('../../assets/img/avatars', false, /\.png$/);
      return path.keys().map(path);
    },
    user() {
      return this.$store.getters.getProfile;
    },
  },
  mounted() {
    if (!this.user.avatar_url) {
      const randomAvatar = this.avatarsList[this.user.uid % this.avatarsList.length];
      this.loadFile({ avatar: randomAvatar });
    }
  },
  components: {
    AvatarPickerModal,
  },
};
</script>

<style scoped>
.uploadImage {
  position: relative;
  width: 128px;
  height: 128px;
  margin: 36px;
}

.empty-picture {
  position: relative;
  display: block;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  object-fit: cover;
}

.empty-picture_edit {
  content: url("../../assets/img/edit-white-sm.svg");
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  background: url("../../assets/img/edit-white-sm.svg") center;
}

.image-input {
  display: none;
}

.sharp {
  background: url("../../assets/img/empty-picture-sharp.svg") center no-repeat;
}

.soft {
  background: url("../../assets/img/empty-picture-soft.svg") center no-repeat;
}

@media (width >= 770px) {
.uploadImage {
  margin: 0 36px 0 0;
}
}
</style>
